import styled from 'styled-components';
export var Description = styled.span.withConfig({
  displayName: "elements__Description",
  componentId: "rjubvf-0"
})(["flex:1;text-align:left;margin-left:2rem;"]);